import { FormEvent, useState } from "react";
import { Card, CardContent } from "@altimateai/lego";
import { createNewConversationGroup } from "../api/index";
import {
  DbtDocsState,
  refetchConversations,
  resetNewConversation,
  updateRightPanelState,
} from "./DbtDocsReducer";
import classes from "../details/styles.module.scss";
import ConversationInputForm from "./ConversationInputForm";
import ConversationHighlightText from "./conversations/ConversationHighlightText";
import { User } from "../../user/types";
import {
  useDbtDocsCollaborationDispatch,
  useDbtDocsCollaborationSelector,
} from "./DbtDocsCollaborationProvider";
import { ConversationGroup } from "./conversations/context/types";

const NewConversationForm = () => {
  const usersList = useDbtDocsCollaborationSelector(
    (state) => state.users,
  ) as Record<string, User>;
  const newConversation = useDbtDocsCollaborationSelector(
    (state) => state.newConversation,
  ) as DbtDocsState["newConversation"];
  const currentUser = useDbtDocsCollaborationSelector((state) =>
    state.currentUserId ? state.users[state.currentUserId] : null,
  ) as User | null;

  const shareId = useDbtDocsCollaborationSelector(
    (state) => state.shareId,
  ) as DbtDocsState["shareId"];
  const dispatch = useDbtDocsCollaborationDispatch();

  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");

  const handleSubmit = async (e?: FormEvent) => {
    e?.stopPropagation();
    e?.preventDefault();

    if (!newConversation || !shareId) {
      return;
    }

    setLoading(true);
    try {
      console.log("saving conversation", newConversation, comment);
      const createGroupResponse = await createNewConversationGroup(
        shareId,
        {
          ...newConversation,
          message: comment,
        },
        "dbt-docs", // this component is used only from dbt docs page
      );
      if (!createGroupResponse.conversation_group_id) {
        console.error(
          "Unable to create conversation group",
          createGroupResponse,
        );
        return;
      }
      console.log(
        "Successfully created conversation group",
        createGroupResponse,
      );
    } catch (err) {
      console.error("error while saving conversation", newConversation, err);
    }
    dispatch(refetchConversations());
    setLoading(false);
    dispatch(updateRightPanelState(true));
    dispatch(resetNewConversation());
    setComment("");
  };

  return (
    <Card className={classes.newConversationForm}>
      <CardContent className="al-pt-4">
        <form onSubmit={handleSubmit}>
          <h4>Add comment</h4>
          <ConversationHighlightText
            meta={newConversation?.meta || ({} as ConversationGroup["meta"])}
          />
          <ConversationInputForm
            comment={comment}
            setComment={setComment}
            loading={loading}
            users={Object.values(usersList)}
            currentUser={currentUser}
            placeholder="Start a conversation or add others with @"
            onEnterKeypress={handleSubmit}
          />
        </form>
      </CardContent>
    </Card>
  );
};

export default NewConversationForm;
